import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import * as Sentry from '@sentry/react';
import React, { useEffect } from 'react';

function Page404() {
  useEffect(() => {
    // Create a custom error object to send to Sentry
    const error = new Error('404 - Page not found') as Error & {
      status?: number;
      url?: string;
    };

    // Add additional context to the error
    error.status = 404;
    error.message = 'Page not found';
    error.url = window.location.href;

    // Send the error to Sentry
    Sentry.captureException(error, {
      level: 'warning', // You can change this to the desired level
    });
  }, []);

  const goBack = () => {
    window.history.back();
  };

  return (
    <div className="flex items-center justify-center ">
      <div className="w-full max-w-2xl space-y-8 rounded-xl bg-white p-12 shadow-2xl">
        <div className="grid place-content-center">
          <img alt="Déclarations Juridiques Logo" src={require('../../../img/logo.svg')} className="mx-auto w-96" />
        </div>
        <div className="text-center">
          <h2 className="mt-6 text-4xl font-extrabold text-gray-900">404</h2>
          <p className="mt-2 text-lg text-gray-600">Oups ! Page non trouvée</p>
        </div>
        <div className="mt-10 space-y-8">
          <div className="-space-y-px rounded-xl shadow-sm">
            <div className="bg-gray-50 px-6 py-6 sm:p-8">
              <h3 className="text-xl leading-6 font-medium text-gray-900">
                Nous n'avons pas trouvé la page que vous recherchez
              </h3>
              <div className="mt-4 max-w-xl text-base text-gray-500">
                <p>La page demandée n'a pas pu être trouvée. Elle a peut-être été supprimée, renommée ou n'existe pas.</p>
              </div>
            </div>
          </div>
          <div className="flex items-center justify-between">
            <button
              onClick={goBack}
              className="group relative flex w-full justify-center rounded-xl border border-transparent bg-rgpd-blue px-6 py-3 text-lg font-medium text-rgpd-white hover:bg-rgpd-blue-dark focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:outline-none"
            >
              <span className="absolute inset-y-0 left-0 flex items-center pl-3">
                <ArrowLeftIcon className="h-6 w-6 text-rgpd-white" aria-hidden="true" />
              </span>
              Retour
            </button>
          </div>
        </div>
        <div className="mt-10 text-center">
          <a href="/" className="text-lg font-medium text-rgpd-blue hover:text-rgpd-blue-dark">
            Retour à l'accueil
          </a>
        </div>
      </div>
    </div>
  );
}

export default Page404;
